import { createContext, useContext, useState, useEffect } from 'react';
import { login as loginApi } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('admin_token'));
  const [loading, setLoading] = useState(false);

  const isAuthenticated = !!token;

  const loginAction = async (username, password) => {
    setLoading(true);
    try {
      const res = await loginApi(username, password);
      const t = res.data.token;
      localStorage.setItem('admin_token', t);
      setToken(t);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Login failed' };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setToken(null);
  };

  useEffect(() => {
    const stored = localStorage.getItem('admin_token');
    if (stored) setToken(stored);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, loginAction, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
